// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/dust-devils.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/dust-devils/dust-devils.js';

mount([g0]);
